import * as React from 'react';

const AFMCSeal = ({id}) => (
    <a href={`//afmccertification.com/practitioner/${id}`} target="_blank" rel="noreferrer">
        <img
            src="//afmccertification.com/wp-content/themes/certified20/images/certified.svg"
            alt="AFMC Certification"
            width="250"
        />
    </a>
);

export default AFMCSeal;
